module.exports = __webpack_public_path__ + "sort-by-menu-down-arrow.ca4fe330c3ad7b6aaaa57897aa64d625.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort-by-menu-down-arrow.svg
// module id = 1158
// module chunks = 0